module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-layout-area",
    attrs: {
      "id": "wlDiv"
    }
  }, [_c('div', {
    staticClass: "d-layout",
    attrs: {
      "id": "20080997"
    }
  }, [_c('div', {
    staticClass: "d-layout-one d-w990"
  }, [_c('div', {
    staticClass: "roulette-174865",
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "moduleclass": "roulette-174865",
      "instanceid": "20081007",
      "module-name": "Lottery",
      "data-has-point": "true"
    }
  }, [_c('div', {
    staticClass: "mc",
    staticStyle: {
      "min-height": "0px"
    }
  }, [_c('div', {
    staticClass: "j-module roulette-container",
    attrs: {
      "module-function": "roulette",
      "module-param": "{lotterycode:'4c908011-b768-4377-b661-c1adf3aca7ab'}"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "roulette-chrome"
  }, [_c('div', {
    staticClass: "pan-bg"
  }, [_vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "go-arrow j-arrow"
  }), _vm._v(" "), _c('div', {
    staticClass: "btn-go-bg"
  }, [_c('div', {
    staticClass: "btn-go j-chrome-run",
    on: {
      "click": function($event) {
        return _vm.getDraw()
      }
    }
  }, [_vm._v("开始")]), _vm._v(" "), _c('div', {
    staticClass: "j-animate-assist animate-assist"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "draw-times"
  }, [_vm._v("\n              您还有抽奖机会\n              "), _c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "page-bg"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogin),
      expression: "isLogin"
    }],
    staticClass: "page-list j-page-list",
    staticStyle: {
      "transform": "translateY(0px)"
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.lucky))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogin),
      expression: "!isLogin"
    }],
    staticClass: "page-num",
    attrs: {
      "title": "登录后可查看抽奖机会数"
    }
  }, [_vm._v("?")])]), _vm._v("\n              次\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "j-roulette-dialog roulette-dialog",
    staticStyle: {
      "top": "350px",
      "display": "none"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "dialog-content-wrap j-dialog-content other"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "r-btn-closed j-r-btn-closed",
    on: {
      "click": function($event) {
        return _vm.close()
      }
    }
  }, [_vm._v("关闭")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "winner-area"
  }, [_c('div', {
    staticClass: "winner-title"
  }, [_c('div', {
    staticClass: "title-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-content"
  }, [_vm._v("获奖名单")])]), _vm._v(" "), _c('div', {
    staticClass: "winner-title2"
  }, [_c('span', {
    staticClass: "w-th"
  }, [_vm._v("中奖者名单")]), _c('span', {
    staticClass: "w-th"
  }, [_vm._v("奖品信息")])]), _vm._v(" "), _c('div', {
    staticClass: "winner-list"
  }, [_c('div', {
    staticClass: "list-wrap j-list-wrap",
    staticStyle: {
      "display": "block"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "j-no-winner no-winner hidden"
  }, [_vm._v("\n                还没出现中奖者，期待您赢取大奖！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-wrap"
  }, [_c('div', {
    staticClass: "bg-widget bg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-widget j-bg-widget bg-2",
    staticStyle: {
      "transform": "translate3d(0px, 0px, 0px)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-widget j-bg-widget bg-3",
    staticStyle: {
      "transform": "translate3d(0px, 0px, 0px)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bg-widget j-bg-widget bg-4",
    staticStyle: {
      "transform": "translate3d(0px, 0px, 0px)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "roulette-ie hidden"
  }, [_c('div', {
    staticClass: "pan-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "j-pan-ie pan-content"
  }), _vm._v(" "), _c('div', {
    staticClass: "pan-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "go j-run"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pan-content csstransforms"
  }, [_c('ul', {
    staticClass: "cn-wrapper j-pan-chrome item-wrap7 bg3"
  }, [_c('li', {
    staticClass: "j-prizeId-1",
    staticStyle: {
      "transform": "rotate(64.28571428571428deg) skew(38.57142857142857deg)"
    },
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "skew(-38.57142857142857deg) rotate(-64.28571428571428deg)"
    }
  }, [_c('span')])]), _vm._v(" "), _c('li', {
    staticClass: "j-prizeId-2",
    staticStyle: {
      "transform": "rotate(12.857142857142847deg) skew(38.57142857142857deg)"
    },
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "skew(-38.57142857142857deg) rotate(-64.28571428571428deg)"
    }
  }, [_c('span')])]), _vm._v(" "), _c('li', {
    staticClass: "j-prizeId-3",
    staticStyle: {
      "transform": "rotate(-38.571428571428584deg) skew(38.57142857142857deg)"
    },
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "skew(-38.57142857142857deg) rotate(-64.28571428571428deg)"
    }
  }, [_c('span')])]), _vm._v(" "), _c('li', {
    staticClass: "j-prizeId-4",
    staticStyle: {
      "transform": "rotate(-90deg) skew(38.57142857142857deg)"
    },
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "skew(-38.57142857142857deg) rotate(-64.28571428571428deg)"
    }
  }, [_c('span')])]), _vm._v(" "), _c('li', {
    staticClass: "j-prizeId-5",
    staticStyle: {
      "transform": "rotate(-141.42857142857144deg) skew(38.57142857142857deg)"
    },
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "skew(-38.57142857142857deg) rotate(-64.28571428571428deg)"
    }
  }, [_c('span')])]), _vm._v(" "), _c('li', {
    staticClass: "j-prizeId-6",
    staticStyle: {
      "transform": "rotate(-192.8571428571429deg) skew(38.57142857142857deg)"
    },
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "skew(-38.57142857142857deg) rotate(-64.28571428571428deg)"
    }
  }, [_c('span')])]), _vm._v(" "), _c('li', {
    staticClass: "j-prizeId-7",
    staticStyle: {
      "transform": "rotate(-244.28571428571428deg) skew(38.57142857142857deg)"
    },
    attrs: {
      "title": ""
    }
  }, [_c('div', {
    staticStyle: {
      "transform": "skew(-38.57142857142857deg) rotate(-64.28571428571428deg)"
    }
  }, [_c('span')])])]), _vm._v(" "), _c('div', {
    staticClass: "pan-mask"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "pan-light j-pan-light pan-list animation"
  }, [_c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li'), _vm._v(" "), _c('li')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-head"
  }, [_c('span', {
    staticClass: "head-text j-head-text"
  }, [_vm._v("没抽奖次数了")]), _vm._v(" "), _c('div', {
    staticClass: "r-icon-closed j-r-icon-closed"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialog-content"
  }, [_c('span', {
    staticClass: "dialog-hack other-tip"
  }), _c('span', {
    staticClass: "j-dialog-text other-tip"
  }, [_vm._v("抽奖次数没了~")]), _vm._v(" "), _c('div', {
    staticClass: "j-prize-tip dialog-prize"
  }), _vm._v(" "), _c('div', {
    staticClass: "j-prize-name dialog-prize"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55b5e590"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/lucky-draw/lucky-draw.vue
// module id = 1606
// module chunks = 1